import { Component, OnInit, computed, inject, input, ChangeDetectionStrategy } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonFieldWidgetBase } from '../common-field-widget-base';
import { CommonUrlField } from '../field';
import { getLabels } from '../field.labels';
import { UtilityService } from '../../../../services/util';


@Component({
	selector: 'common-url-field',
	imports: [FormsModule],
	templateUrl: './common-url-field.widget.html',
	changeDetection: ChangeDetectionStrategy.Eager,
	host: { '[class.d-none]': 'isExcluded()' },
})
export class CommonUrlFieldWidget extends CommonFieldWidgetBase<string, CommonUrlField> implements OnInit {

	public readonly field = input.required<CommonUrlField>();
	private readonly util = inject(UtilityService);

	public readonly labels = computed(() => {
		const config = this.field().config();

		return {
			...getLabels(config.isSpanish),
			maxLength: config.isSpanish ? `Texto muy largo. Máximo de ${config.max} caracteres.` : `Text too long. Max of ${config.max} characters.`
		}

	});


	public readonly renderedModel = computed(() => {
		const value = this.field().pendingValue() ?? this.field().actualValue();
		return this.render(value);
	});

	ngOnInit() {
		this.onInit(this.field());
	}


	public onChange(value: string) {
		this.processChange(value);
	}


	public async onBlur() {
		await this.processBlur();
	}


	protected override cleanValue(value: string) {
		return value.trim();
	}


	protected validate(value: string): string {

		const config = this.field().config();
		const labels = this.labels();

		if (value.length == 0 && config.isRequired) return labels.missingRequired();

		if (value.length && !this.util.text.isValidUrl(value)) return labels.notValidUrlPattern();
		if (config.max && value.length > config.max) return this.labels().maxLength;

		return '';
	}


	public setFocus() {
		console.error('setFocus() not implemented');
	}

}